
window.svelteComponents = {
  AdvancedCreditPricing: require('./AdvancedCreditPricing/index.svelte').default,
  BasicCreditPricing: require('./BasicCreditPricing/index.svelte').default,
  PricingPerDurationTable: require('./PricingPerDurationTable/index.svelte').default,
  ViewOrComposeMessage: require('./ViewOrComposeMessage/index.svelte').default
}
